import { render, staticRenderFns } from "./InventoryPricingCRUD.vue?vue&type=template&id=5e925f13&scoped=true&"
import script from "./InventoryPricingCRUD.vue?vue&type=script&lang=js&"
export * from "./InventoryPricingCRUD.vue?vue&type=script&lang=js&"
import style0 from "./InventoryPricingCRUD.vue?vue&type=style&index=0&id=5e925f13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e925f13",
  null
  
)

export default component.exports